"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerSupportQueueSocketErrorCode = exports.PartnerSupportQueueSocketEventType = void 0;
var PartnerSupportQueueSocketEventType;
(function (PartnerSupportQueueSocketEventType) {
    PartnerSupportQueueSocketEventType["Join"] = "partner-support-queue-join";
    PartnerSupportQueueSocketEventType["Leave"] = "partner-support-queue-leave";
    PartnerSupportQueueSocketEventType["Probe"] = "partner-support-queue-probe";
    PartnerSupportQueueSocketEventType["Error"] = "partner-support-queue-error";
})(PartnerSupportQueueSocketEventType || (exports.PartnerSupportQueueSocketEventType = PartnerSupportQueueSocketEventType = {}));
var PartnerSupportQueueSocketErrorCode;
(function (PartnerSupportQueueSocketErrorCode) {
    PartnerSupportQueueSocketErrorCode["WebSocketRequired"] = "websocketRequired";
    PartnerSupportQueueSocketErrorCode["InvalidPayload"] = "invalidPayload";
    PartnerSupportQueueSocketErrorCode["Unauthenticated"] = "unauthenticated";
    PartnerSupportQueueSocketErrorCode["Unauthorized"] = "unauthorized";
})(PartnerSupportQueueSocketErrorCode || (exports.PartnerSupportQueueSocketErrorCode = PartnerSupportQueueSocketErrorCode = {}));
